// extracted by mini-css-extract-plugin
export var audioPlayer = "_sa-0";